export default {
      id: "copyright-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#copyright",
      toString: function () {
        return this.url;
      }
    }